<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar/>
    <TheAside/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main mt-1">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import {ACCESS_TOKEN_EXPIRED} from "@/constant";
import {authLogout} from "@/security/index";

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside
  },
  data() {
    return {
      intervalAutoLogout: null,
    }
  },
  mounted() {
    this.checkTimeExpToken();
    this.countAutoLogout();
  },
  methods: {
    countAutoLogout() {
      let timeExpired = localStorage.getItem(ACCESS_TOKEN_EXPIRED)
      if (timeExpired) {
        let expiredTime = new Date(timeExpired * 1)
        this.intervalAutoLogout = setInterval(() => {
          let time = new Date();
          if (time >= expiredTime) {
            authLogout();
          }
        }, 1000)
      }
    },
    checkTimeExpToken() {
      let timeExpired = localStorage.getItem(ACCESS_TOKEN_EXPIRED)
      if (timeExpired) {
        let expiredTime = new Date(timeExpired * 1)
        let time = new Date();
        if (time >= expiredTime) {
          authLogout();
        }
      }
    },
  },
  // logout: function () {
  //   let that = this;
  //   that.$helper.loadDataSource({
  //     loading: that.loading,
  //     url: "/users/logout",
  //     successCallback: function (response) {
  //       if (response.status === 200) {
  //         let dataResponse = response.data;
  //         if (dataResponse.returnCode !== 1) {
  //           that.showErrorMsg({message: that.$helper.getStringError(dataResponse.data)});
  //         } else {
  //         }
  //       }
  //     },
  //     errorCallback: function (error) {
  //       that.$helper.handleError(that.$router, error);
  //     }
  //   });
  // },
  computed: {},
  destroyed() {
    clearInterval(this.intervalAutoLogout)
  },
}
</script>

<style scoped>
/* .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
} */
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
